import createSvgIcon from '../Utils/CreateSvgIcon';

export const Play = createSvgIcon(<path d="M20 12L5 3L5 21L20 12Z" />, 'Play');
